import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../../bdo/enums/trackingParts.enum';
import { ReBaseData } from '../../utils/re-base-data';
import { TrackingService } from '../../../bdo/services/tracking.service';
import { Srcs } from '../../models/switchCardConfiguration';

@Component({
    selector: 'bdo-link-tile',
    templateUrl: './link-tile.component.html',
    styleUrls: ['./link-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LinkTileComponent {
  @Input() iconSrc: Srcs;
  @Input() title: string;
  @Input() linktext: string;
  @Input() destination: string;
  @Input() externalDestination: string;
  @Input() description: string = ''; // optional
  @Input() trackingLocation: string;
  @Input() trackingDestination: string;
  protected reBaseData = ReBaseData;

  constructor(
    private trackingService: TrackingService
  ) { }

  track(destination: string) {
    if (this.trackingLocation && destination) {
      this.trackingService.postSimpleTracking(this.trackingLocation, TRACKING.ACTION.GOTO, destination);
    }
  }

}
